import { memo } from 'react';

export type WorkspaceAgentActionsMenuKeyboardHintProps = {
  hint: string;
};

/** Strato `KeyHint` / prototype Actions menu `shortcutChip`. */
export const WorkspaceAgentActionsMenuKeyboardHint = memo(({ hint }: WorkspaceAgentActionsMenuKeyboardHintProps) => {
  return (
    <kbd
      aria-hidden
      className="flex size-4 shrink-0 items-center justify-center rounded border ads:border-subtle border-gray-3 font-mono ads:text-primary text-12 text-gray-12 leading-4"
    >
      {hint}
    </kbd>
  );
});

WorkspaceAgentActionsMenuKeyboardHint.displayName = 'WorkspaceAgentActionsMenuKeyboardHint';
